export enum GuideTypeEnum {
    consulta = 1,
    spSadt = 2,
    honorarios = 3,
    internacao = 4,
}